var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CFooter',{attrs:{"fixed":false}},[_c('div',[_c('a',{attrs:{"href":"https://raymas.in","target":"_blank"}},[_vm._v("Raymas")]),_c('span',{staticClass:"ml-1"},[_vm._v("© "+_vm._s(new Date().getFullYear())+" Team Manakkal OMS 3.0 ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }